import { useState } from "react";
import type { AccountWithBalance } from "./useAccountFetcher";

export type TopUpStep = 1 | 2 | 3 | 4;

const TREASURY_ACCOUNT: AccountWithBalance = {
  address: "0x8a63054C5daf4c9675016A0896C5705CE9142087",
  path: "44'/60'/0'/0/0",
  xpub: [],
  balance: 0,
};

export interface UseTopUpReturn {
  step: TopUpStep;
  phase: TopUpStep;
  amount: string;
  setAmount: (v: string) => void;
  setPhase: (ph: TopUpStep) => void;
  selectedAccount: AccountWithBalance | null;
  treasuryAccount: AccountWithBalance;
  goToStep2: () => void;
  goToStep3: () => void;
  selectAccount: (account: AccountWithBalance) => void;
  goBack: () => void;
  reset: () => void;
}

export function useTopUp(): UseTopUpReturn {
  const [step, setStep] = useState<TopUpStep>(1);
  const [phase, setPhase] = useState<TopUpStep>(1);
  const [amount, setAmount] = useState("");
  const [selectedAccount, setSelectedAccount] =
    useState<AccountWithBalance | null>(null);
  const goToStep2 = () => {
    const parsed = parseFloat(amount);
    if (!amount || isNaN(parsed) || parsed <= 0) return;
    setStep(2);
  };

  const goToStep3 = () => {
    const parsed = parseFloat(amount);
    if (!amount || isNaN(parsed) || parsed <= 0) return;
    setStep(3);
    setPhase(2);
  };

  const selectAccount = (account: AccountWithBalance) => {
    setSelectedAccount(account);
    setStep(3);
  };

  const goBack = () => {
    setStep((prev) => Math.max(1, prev - 1) as TopUpStep);
  };

  const reset = () => {
    setStep(1);
    setAmount("");
    setSelectedAccount(null);
  };

  return {
    step,
    phase,
    amount,
    setAmount,
    setPhase,
    selectedAccount,
    treasuryAccount: TREASURY_ACCOUNT,
    goToStep2,
    goToStep3,
    selectAccount,
    goBack,
    reset,
  };
}
